import { useEffect, useState } from 'react';

import { getLTLCommentQualifiers } from 'lib/api/getLTLCommentQualifiers';

export interface CommentTypeOption {
  value: string;
  label: string;
}

export function useCommentTypes(): {
  options: CommentTypeOption[];
  isLoading: boolean;
} {
  const [options, setOptions] = useState<CommentTypeOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);

    getLTLCommentQualifiers().then((result) => {
      if (cancelled) {
        return;
      }

      setIsLoading(false);

      if (result.isOk() && result.value.qualifiers?.length) {
        setOptions(
          result.value.qualifiers.map((q) => ({
            value: q.value,
            label: q.label,
          }))
        );
      } else {
        setOptions([]);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return { options, isLoading };
}
